<template>
  <div>
    <section class="con7">
      <div class="container inner">
        <img src="@/assets/img/centerone/con7/icon.png" alt="img" />
        <p>우리는 리더의 삶과<br />일터에 변화를 만듭니다.</p>
        <p>
          우리의 목표는 리더의 의식 진전을 통해 삶과 일터의 변화를 만드는
          것입니다.<br />현업 리더들이 창조성을 발휘하고, 팀의 성공을 만들 수
          있도록<br />명상을 비롯한 다양한 웰니스 기법을 제안합니다.<br />교육을
          넘어 내면의 성찰, 더 큰 영역으로 성장을,<br />그리고 변화를 만드는
          동료 리더를 만나는 ‘연결’을<br />이끌어낼 수 있도록 센터원이 함께
          하겠습니다.
        </p>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.br-pc {
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
}

// con7
.con7 {
  padding: 70px 0 104px;
  background: url(~@/assets/img/centerone/con7/bg.png) no-repeat center / cover;

  @media screen and (min-width: 1200px) {
    padding: 288px 0;
  }

  .inner {
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    img {
      width: 32px;
      margin-bottom: 30px;

      @media screen and (min-width: 1200px) {
        width: 48px;
      }
    }

    p {
      &:nth-of-type(1) {
        font-size: 34px;
        font-weight: 700;
        color: #fff;
        line-height: 42px;
        margin-bottom: 20px;

        @media screen and (min-width: 1200px) {
          font-size: 64px;
          line-height: 80px;
          margin-bottom: 90px;
        }
      }

      &:nth-of-type(2) {
        color: #9f9f9f;
        line-height: 22px;

        @media screen and (min-width: 1200px) {
          font-size: 24px;
          line-height: 34px;
        }
      }
    }
  }
}
</style>
